import { render } from "./NouvelleGenerationIA.vue?vue&type=template&id=2620ed22&scoped=true"
import script from "./NouvelleGenerationIA.vue?vue&type=script&lang=js"
export * from "./NouvelleGenerationIA.vue?vue&type=script&lang=js"

import "./NouvelleGenerationIA.vue?vue&type=style&index=0&id=2620ed22&scoped=true&lang=css"

import exportComponent from "/builds/phl/phlsupport/deploy-support-cli/front_vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2620ed22"]])

export default __exports__